{
    "SCOPEASSIGNMENT_CME": "CME:",
    "SCOPEASSIGNMENT_FilterRecursively": "Recursief filteren:",
    "SCOPEASSIGNMENT_TelServer": "Telefonie server:",
    "SCOPEASSIGNMENT_Partition": "Verdeling:",
    "NAME": "ScopeAssignment"
}